// extracted by mini-css-extract-plugin
export default {"heading":"toc_heading__7hF1x","ule":"toc_ule__7QpNL","container":"toc_container__zfbE1"};